import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components/macro'
import GalleryImage from 'components/atoms/gallery-image'
import Carousel from 'components/molecules/carousel'
import SphereImageViewer from 'components/molecules/sphere-image-viewer'
import { isSphereImage } from 'utilities/utils'

const StyledGalleryImage = styled(GalleryImage)`
  height: ${({ fullHeight }) => (fullHeight ? '100%' : '')};
`

const StyledSphereImageViewer = styled(SphereImageViewer)`
  height: ${({ $fullHeight }) => ($fullHeight ? '100%' : '')};
`

const ImageCarousel = forwardRef(
  ({ fullHeight, images, label, ratio, ...restProps }, ref) => {
    return (
      <Carousel ref={ref} fullHeight={fullHeight} {...restProps}>
        {images.map((image, index) =>
          isSphereImage(image) ? (
            <StyledSphereImageViewer
              key={index.toString()}
              src={image.src}
              ratio={fullHeight ? undefined : ratio}
              $fullHeight={fullHeight}
            />
          ) : (
            <StyledGalleryImage
              label={label}
              key={index.toString()}
              alt={`car detail image ${index}`}
              src={image.src}
              fullHeight={fullHeight}
              ratio={ratio}
            />
          ),
        )}
      </Carousel>
    )
  },
)

ImageCarousel.propTypes = {
  fullHeight: PropTypes.bool,
  images: PropTypes.array.isRequired,
  label: PropTypes.string,
  ratio: PropTypes.number,
}

ImageCarousel.defaultProps = {
  fullHeight: false,
  label: null,
  ratio: undefined,
}

export default ImageCarousel
